export enum HospitalChannel {
  CREATE = 'hospital::create',
  EDIT = 'hospital::patch',
  DELETE = 'hospital::delete',
}
